import { render, staticRenderFns } from "./ListMobile.vue?vue&type=template&id=90fec95a&"
import script from "./ListMobile.vue?vue&type=script&lang=js&"
export * from "./ListMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports